<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <ReturnTreasureViewOne @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>

    <!-- theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <ReturnTreasureViewTwo @get-deposit-claim="() => emits('getDepositClaim')"
            @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>

    <!-- theme Three -->
    <div v-if="themeStore.themeIndex === 3">
        <ReturnTreasureViewThree @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>

    <!-- theme Four -->
    <div v-if="themeStore.themeIndex === 4">
        <ReturnTreasureViewFour @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores/theme';
import ReturnTreasureViewOne from '@/themes/themeOne/returnTreasure/returnTreasureView.vue';
import ReturnTreasureViewTwo from '@/themes/themeTwo/returnTreasure/returnTreasureView.vue';
import ReturnTreasureViewThree from '@/themes/themeThree/returnTreasure/returnTreasureView.vue';
import ReturnTreasureViewFour from '@/themes/themeFour/returnTreasure/returnTreasureView.vue';
const themeStore = useThemeStore()
const emits = defineEmits(['getDepositClaim', 'resetShowTreasurePopup'])
const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}
</script>
